module.exports = __webpack_public_path__ + "static/media/Soundcloud.27bd5c37.svg";